import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  OnChanges,
  Output,
  Renderer2,
  signal,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonModule } from '@angular/common';
import { CountryData } from '../../models/common.interfaces';

@Component({
  selector: 'country-list',
  templateUrl: './country-dropdown.component.html',
  styleUrls: ['./country-dropdown.component.scss'],
  imports: [CommonModule],
})
export class CountryListDropdown implements OnInit, OnChanges {
  @Input() countryList: CountryData[] = [];
  @Input() selectedCountry: any;
  @Input() align = 'right';

  @Output() changedCountryCode = new EventEmitter<string>();

  @ViewChild('selectFlags') selectFlagsElementRef!: ElementRef;
  private isFirstLoad = true;
  private _isShowListCountryFlags = false;

  set isShowListCountryFlags(value: boolean) {
    this._isShowListCountryFlags = value;
    this.changeDetectorRef.markForCheck();
  }
  get isShowListCountryFlags(): boolean {
    return this._isShowListCountryFlags;
  }

  outsideClickSelectFlags: (() => void) | undefined = undefined;
  constructor(
    private renderer: Renderer2,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  countryCodes: string[] = [];
  customLabels: { [key: string]: string } = {};
  selectedCountryCode = '';
  selectedCountryFlagImg = '';
  readonly showList = signal(false);

  ngOnInit(): void {}

  ngOnChanges(): void {
    if (this.countryList && this.countryList.length > 0) {
      for (let i = 0; i < this.countryList.length; i++) {
        let string = this.countryList[i]?.label || '';
        let string2 = this.countryList[i]?.label || '';
        string = string.toLowerCase();
        this.countryCodes.push(string);
        this.customLabels[string] = string2;
      }
      this.countryCodes = this.countryCodes.sort();
      this.selectedCountryCode = this.customLabels[this.selectedCountry];
      const selectedCountry = this.countryList.find(
        el => el.label === this.selectedCountryCode
      );
      this.selectedCountryFlagImg = selectedCountry?.flag || '';
      this.isFirstLoad = false;
    }
  }

  public changeSelectedCountryCode(value: CountryData): void {
    this.selectedCountryCode = value?.label || '';
    this.selectedCountryFlagImg = value?.flag || '';
    this.closeListCountryFlags();
    this.changedCountryCode.emit(this.selectedCountryCode.toLowerCase());
  }

  public toggleListCountryFlags(): void {
    if (this.isShowListCountryFlags) {
      this.closeListCountryFlags();
    } else {
      this.openListCountryFlags();
    }
  }

  private openListCountryFlags(): void {
    this.isShowListCountryFlags = true;
    this.subscribeOutsideClickSelectFlags();
  }

  private closeListCountryFlags(): void {
    this.isShowListCountryFlags = false;
    this.unsubscribeOutsideClickSelectFlags();
  }

  private subscribeOutsideClickSelectFlags(): void {
    this.outsideClickSelectFlags = this.renderer.listen(
      'document',
      'click',
      (event: Event) => {
        if (!this.selectFlagsElementRef.nativeElement.contains(event.target)) {
          this.closeListCountryFlags();
        }
      }
    );
  }

  private unsubscribeOutsideClickSelectFlags(): void {
    if (this.outsideClickSelectFlags) {
      this.outsideClickSelectFlags();
      this.outsideClickSelectFlags = undefined;
    }
  }
}
